import { ValidationBase } from "@inter-ikea-core/core-toolbox";
import { generateValidationFail } from "../utils/helpers";
import { COMPONENT_IDS } from "@inter-ikea-storagetwo/range/dist/storage2ComponentIDs";
const FAIL_MSG = "Adjustable cloth rail can't sit here";
export default class AdjustableClothRailValidation extends ValidationBase {
    constructor() {
        super(...arguments);
        this.id = "AdjustableClothRailValidation";
    }
    validateCurrentState(_entity) {
        return null;
    }
    validateSnap(snapActionCandidate) {
        const { guest, host } = snapActionCandidate;
        if (!guest.hasComponent(COMPONENT_IDS.INSERT_ATTACHMENT_COMPONENT))
            return null;
        if (!host.hasComponent(COMPONENT_IDS.ADJUSTABLE_COMPONENT))
            return generateValidationFail(snapActionCandidate.guest, FAIL_MSG);
        return null;
    }
}
